import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import MobileBottomBar from "@/components/feature/MobileBottomBar";

const services = [
  {
    icon: "ri-flower-line",
    title: "Individuell gebunden",
    desc: "Jeder Strauß wird nach Ihren Wünschen und Ideen von Hand gebunden – mit Liebe zum Detail.",
  },
  {
    icon: "ri-sparkling-2-line",
    title: "Frischegarantie",
    desc: "Wir beziehen unsere Blumen direkt vom Großhandel – für maximale Frische und Haltbarkeit.",
  },
  {
    icon: "ri-seedling-line",
    title: "Schnittblumen-Auswahl",
    desc: "Besondere und saisonale Schnittblumen, die Sie nicht überall finden.",
  },
  {
    icon: "ri-plant-line",
    title: "Dekorierte Pflanzen",
    desc: "Topfpflanzen in schönen Übertöpfen, verziert mit Naturmaterialien – perfekt zum Verschenken.",
  },
  {
    icon: "ri-gift-line",
    title: "Geschenkideen",
    desc: "Von Blumen bis Dekoration – passende Geschenke für Haus, Garten und besondere Anlässe.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Vorbestellung & Abholung",
    desc: "Reservieren Sie Ihren Wunschstrauß telefonisch oder vor Ort – wir halten ihn bereit.",
  },
];

const galleryItems = [
  {
    src: "https://storage.helloreaddy.io/project_files/ccd3f37f-a1a3-49ba-8460-6107752c615a/95d101fd-7a0a-4238-aff1-c8157623ad99_compressed_Blumen-Manufaktur.webp",
    alt: "Frische Blumensträuße in Metallkannen bei Florale Manufaktur",
    label: "Unsere Frischeauswahl",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Close-up%20of%20florist%20hands%20tying%20a%20bouquet%20with%20pink%20peonies%20white%20roses%20and%20eucalyptus%20on%20wooden%20workbench%2C%20natural%20workshop%20light%2C%20greenery%20and%20ribbon%20scattered%20around%2C%20authentic%20floristry%20scene%2C%20warm%20earthy%20tones&width=800&height=1000&seq=bouquet-ex-handgebunden&orientation=portrait",
    alt: "Florist beim Binden eines individuellen Straußes",
    label: "Handgebunden nach Wunsch",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Beautiful%20assortment%20of%20fresh%20cut%20flowers%20displayed%20in%20metal%20buckets%20on%20a%20wooden%20shelf%20in%20a%20flower%20shop%2C%20tulips%20roses%20ranunculus%20and%20greenery%2C%20soft%20natural%20daylight%2C%20colorful%20vibrant%20floristry%20photography&width=800&height=1000&seq=bouquet-ex-schnittblumen&orientation=portrait",
    alt: "Bunte Auswahl an frischen Schnittblumen",
    label: "Täglich frische Schnittblumen",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Elegant%20potted%20orchid%20plant%20in%20a%20beautiful%20white%20ceramic%20pot%20decorated%20with%20natural%20jute%20ribbon%20and%20small%20moss%20balls%2C%20placed%20on%20a%20light%20wooden%20table%2C%20soft%20natural%20lighting%2C%20gift-ready%20floristry%20product%20photography%2C%20clean%20neutral%20background&width=800&height=1000&seq=bouquet-ex-topfpflanze&orientation=portrait",
    alt: "Dekorierte Orchidee in Keramiktopf als Geschenk",
    label: "Dekorierte Topfpflanzen",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Artfully%20arranged%20gift%20basket%20with%20a%20small%20bouquet%20of%20wildflowers%2C%20scented%20candle%2C%20and%20decorative%20dried%20pampas%20grass%20on%20a%20linen%20cloth%2C%20warm%20natural%20light%2C%20cozy%20aesthetic%20floristry%20gift%20photography%2C%20soft%20pastel%20and%20earth%20tones&width=800&height=1000&seq=bouquet-ex-geschenk&orientation=portrait",
    alt: "Florales Geschenkarrangement mit Kerze und Trockenblumen",
    label: "Geschenkideen & Sets",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Stunning%20seasonal%20autumn%20bouquet%20with%20orange%20dahlias%2C%20deep%20red%20chrysanthemums%2C%20dried%20wheat%20stems%2C%20and%20berries%20in%20a%20terracotta%20ceramic%20vase%2C%20warm%20golden%20light%2C%20rich%20autumn%20floristry%20photography%2C%20cozy%20earthy%20atmosphere&width=800&height=1000&seq=bouquet-ex-saisonal&orientation=portrait",
    alt: "Saisonaler Herbststrauß mit Dahlien und Chrysanthemen",
    label: "Saisonale Kreationen",
  },
];

export default function StraussGeschenk() {
  return (
    <>
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-[500px] md:min-h-[600px] lg:min-h-[700px] flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src="https://storage.helloreaddy.io/project_files/ccd3f37f-a1a3-49ba-8460-6107752c615a/95d101fd-7a0a-4238-aff1-c8157623ad99_compressed_Blumen-Manufaktur.webp"
            alt="Frische Blumensträuße in Metallkannen bei Florale Manufaktur"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        </div>

        {/* Hero Content */}
        <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center pt-20">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-4 md:mb-6 max-w-4xl mx-auto leading-tight drop-shadow-lg">
            Sträuße & Geschenkfloristik
          </h1>
          <p className="text-white/90 text-base md:text-lg lg:text-xl max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed drop-shadow-md">
            Kein Strauß ist wie der andere. Wir verbinden Farben, Formen und ausgewählte Blüten zu einem persönlichen floralen Unikat.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center px-8 py-3.5 bg-background-50 text-foreground-950 rounded-md text-sm font-medium hover:bg-white transition-colors whitespace-nowrap shadow-lg"
            >
              Strauß vorbestellen
            </Link>
            <a
              href="https://www.fleurop.de/partnerfloristen/fleurop-filialen/26789-leer/florale-manufaktur-blumen-stoehr-gmbh-heisfelder-str-105"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-3.5 border-2 border-white/80 text-white rounded-md text-sm font-medium hover:bg-white/10 transition-colors whitespace-nowrap"
            >
              <i className="ri-send-plane-line w-4 h-4 flex items-center justify-center mr-2"></i>
              Blumen über Fleurop versenden
            </a>
          </div>
        </div>
      </section>

      <main>
        {/* Service-Grid */}
        <section className="bg-background-50 py-16 md:py-24 px-4 md:px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12 md:mb-16">
              <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
                Unsere Leistungen
              </h2>
              <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
                Von klassischen Sträußen bis zu kreativen Geschenkideen – wir zaubern für jeden Geschmack.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {services.map((service) => (
                <div
                  key={service.title}
                  className="bg-background-100 rounded-lg p-6 md:p-8 group hover:bg-background-200/70 transition-colors"
                >
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 mb-5">
                    <i className={`${service.icon} text-xl md:text-2xl`} />
                  </div>
                  <h3 className="font-heading text-lg md:text-xl text-foreground-950 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                    {service.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Galerie */}
        <section className="bg-background-100 py-16 md:py-24 px-4 md:px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12 md:mb-16">
              <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
                Unsere Kreationen
              </h2>
              <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
                Jedes Bild zeigt ein echtes Beispiel aus unserer Manufaktur – für Sie gebunden, verpackt und dekoriert.
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
              {galleryItems.map((item, i) => (
                <div
                  key={i}
                  className="group relative rounded-lg overflow-hidden"
                >
                  <div className="aspect-[4/5] w-full">
                    <img
                      src={item.src}
                      alt={item.alt}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent pt-12 pb-4 px-3 md:px-4">
                    <p className="text-background-50 font-heading text-sm md:text-base font-medium">
                      {item.label}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bg-background-50 py-16 md:py-24 px-4 md:px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-4">
              Ihr Strauß wartet auf Sie
            </h2>
            <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto mb-10">
              Kommen Sie vorbei oder rufen Sie uns an – wir beraten Sie gerne persönlich und binden Ihren individuellen Strauß.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/kontakt"
                className="inline-flex items-center justify-center px-8 py-3.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <span className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-phone-line" />
                </span>
                Strauß vorbestellen
              </Link>
              <a
                href="https://www.fleurop.de/partnerfloristen/fleurop-filialen/26789-leer/florale-manufaktur-blumen-stoehr-gmbh-heisfelder-str-105"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-8 py-3.5 border border-primary-300 text-primary-700 rounded-md text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap"
              >
                <span className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-send-plane-line" />
                </span>
                Blumen über Fleurop versenden
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <MobileBottomBar />
    </>
  );
}